module.exports = __webpack_public_path__ + "static/media/lights_101.46a74c56.ico";